import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import { Site } from '@swf/core/enums';
import { select } from '@swf/core/store';

import {
  TXTWCL_But_donXt_panicX_WeXll_be_righ_ELL,
  TXTWCL_In_the_meanwhileX_see_our_excl_ELL,
  TXTWCL_SorryX_we_are_under_maintenanc_ELL
} from './ServiceUnavailable.messages.json';
import styles from './ServiceUnavailable.scss';
import background from './assets/background.png';
import diamondStars from './assets/diamond-stars.png';
import luckOTheStars from './assets/luck-o-the-stars.png';
import releaseTheKraken from './assets/release-the-kraken.png';
import victoryTribes from './assets/victory-tribes.png';

const games = [
  { image: releaseTheKraken, name: 'Release the Kraken', link: 'https://youtu.be/pBvtfggyF98' },
  { image: luckOTheStars, name: "Luck O'The Stars", link: 'https://youtu.be/aqBWpCowquc' },
  { image: victoryTribes, name: 'Victory Tribes', link: 'https://youtu.be/nOj_yFlT6uc' },
  { image: diamondStars, name: 'Diamond Stars', link: 'https://youtu.be/Q_bCSRED83o' }
];

// @TODO vertical-specific maintenance page
const ServiceUnavailable: React.FC = () => {
  const siteId = useSelector(select.site.getId);

  return (
    <div className={styles.container}>
      <Translation {...TXTWCL_SorryX_we_are_under_maintenanc_ELL}>
        {(message) => <h2 className={styles.title}>{message}</h2>}
      </Translation>
      <Translation {...TXTWCL_But_donXt_panicX_WeXll_be_righ_ELL}>
        {(message) => <h4 className={styles.subTitle}>{message}</h4>}
      </Translation>
      <img className={styles.background} src={background} alt="" />
      {siteId !== Site.NET && (
        <>
          <Translation {...TXTWCL_In_the_meanwhileX_see_our_excl_ELL}>
            {(message) => <h3 className={styles.callout}>{message}</h3>}
          </Translation>
          <div className={styles.games}>
            {games.map((game) => (
              <a
                className={styles.game}
                href={game.link}
                target="_blank"
                rel="noopener noreferrer"
                key={game.name}
              >
                <img src={game.image} alt={game.name} />
              </a>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ServiceUnavailable;
